import { render, staticRenderFns } from "./NonLoginChatRoom.vue?vue&type=template&id=4e5bda54&scoped=true"
import script from "./NonLoginChatRoom.vue?vue&type=script&lang=ts"
export * from "./NonLoginChatRoom.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginChatRoom.vue?vue&type=style&index=0&id=4e5bda54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5bda54",
  null
  
)

export default component.exports